import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import { yearCheckList, downloadTemp } from "@/api/management/staff";
import Detail from "./details.vue";
import importExcel from "@/components/dialog/import/importExcel.vue";
export default {
  name: "search",
  components: {
    Sift: Sift,
    Detail: Detail,
    importExcel: importExcel
  },
  props: [],
  data: function data() {
    return {
      uplodData: {
        state: false,
        type: ""
      },
      siftData: [{
        col: 6,
        type: "year",
        key: "yearCheckTime",
        label: "年份",
        placeholder: "请选择年份",
        default: "",
        sysDatasourceQuery: "yyyy"
      }, {
        type: "select",
        key: "yearCheckResult",
        label: "考评结果",
        placeholder: "请选择考评结果",
        default: "",
        col: 6,
        data: [{
          value: "0",
          label: "优秀等次"
        }, {
          value: "1",
          label: "合格等次"
        }, {
          value: "2",
          label: "不合格等次"
        }, {
          value: "3",
          label: "不确定等次"
        }]
      }, {
        type: "text",
        key: "userName",
        label: "姓名",
        placeholder: "请输入姓名",
        default: "",
        col: 6
      }],
      loading: false,
      current: 1,
      size: 10,
      total: 0,
      tableData: [],
      detailData: {
        state: false
      },
      detailList: {
        userName: "",
        list: []
      }
    };
  },
  computed: {},
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.initPage();
    });
  },
  mounted: function mounted() {},
  methods: {
    initPage: function initPage() {
      this.current = 1;
      this.getList();
    },
    changePage: function changePage(page) {
      this.current = page;
      this.getCaseList();
    },
    getList: function () {
      var _getList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var searchData, params, _yield$yearCheckList, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                searchData = this.$refs.needSift.getValue();
                params = _objectSpread(_objectSpread({}, searchData), {}, {
                  current: this.current,
                  size: this.size
                });
                _context.next = 5;
                return yearCheckList(params);

              case 5:
                _yield$yearCheckList = _context.sent;
                data = _yield$yearCheckList.data;
                this.loading = false;

                if (data.code == 0) {
                  this.tableData = data.data.records;
                  this.total = data.data.total;
                } else {
                  this.$message.error(data.data.msg);
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getList() {
        return _getList.apply(this, arguments);
      }

      return getList;
    }(),
    // 详情
    toDetails: function () {
      var _toDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var params, _yield$yearCheckList2, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.detailData.state = true;
                params = {
                  current: 1,
                  size: 10,
                  userId: row.userId
                };
                this.detailList.userName = row.userName;
                _context2.next = 5;
                return yearCheckList(params);

              case 5:
                _yield$yearCheckList2 = _context2.sent;
                data = _yield$yearCheckList2.data;

                if (data.code == 0) {
                  if (data.data.records.length <= 3) {
                    this.detailList.list = data.data.records;
                  } else {
                    this.detailList.list = data.data.records.slice(0, 3);
                  }
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function toDetails(_x) {
        return _toDetails.apply(this, arguments);
      }

      return toDetails;
    }(),
    closeUplod: function closeUplod(val) {
      this.uplodData.state = val;
    },
    saveSuccess: function saveSuccess() {
      this.initPage();
    },
    importExcel: function importExcel() {
      this.uplodData.state = true;
    },
    // 模板下载
    downloadTemplate: function downloadTemplate() {
      this.downloadFn(downloadTemp());
    },
    downloadFn: function downloadFn(url) {
      var _this2 = this;

      this.$DownLoad(url, null, function (res) {
        if (res.status != 200) {
          _this2.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this2.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    }
  }
};